module.exports = __webpack_public_path__ + "static/media/notification.d0287b67.svg";